<!--
 * @Author: mzw
 * @Date: 2021-09-22 15:13:50
 * @LastEditors: zhangyu
 * @LastEditTime: 2021-12-31 10:30:30
 * @Description: 发票编辑弹窗组件
-->
<template>
  <el-dialog :title="dialogTitle" :visible.sync="invoiceVisible" width="720px" :before-close="closeInviceHandle" :close-on-click-modal="false">
      <div class="addArea" v-if="invoiceForm">
          <div class="add_form">
                <el-form label-width="110px" :model="invoiceForm" :rules="invoiceFormRules" ref="invoiceForm" label-position="right">
                    <el-form-item label="发票类型：" prop="invoiceType">
                        <el-radio-group v-model="invoiceForm.invoiceType">
                          <el-radio label="20">增值税专用发票</el-radio>
                          <el-radio label="10">增值税普通发票</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="发票抬头" prop="companyName">
                        <el-input v-model="invoiceForm.companyName" :maxlength="40"></el-input>
                    </el-form-item>
                    <el-form-item label="税务登记证号:" prop="taxpayerIdentity" :rules="invoiceForm.invoiceType === '20' ? invoiceFormRules.taxpayerIdentity : [{ required: false, message: '', trigger: 'blur' }]">
                        <el-input v-model="invoiceForm.taxpayerIdentity" maxlength="50" placeholder="" @input="invoiceForm.taxpayerIdentity=invoiceForm.taxpayerIdentity.replace(/[^A-Za-z0-9]/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行名称:" prop="openingBank"
                        :rules="invoiceForm.invoiceType === '20' ? invoiceFormRules.openingBank : [{ required: false, message: '', trigger: 'blur' }]">
                        <el-input v-model="invoiceForm.openingBank" :maxlength="100"></el-input>
                    </el-form-item>
                    <el-form-item label="基本开户账号:" prop="bankAccountNo"
                        :rules="invoiceForm.invoiceType === '20' ? invoiceFormRules.bankAccountNo : [{ required: false, message: '', trigger: 'blur' }]">
                        <el-input v-model="invoiceForm.bankAccountNo" :maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="注册场所地址:" prop="companyAddress"
                        :rules="invoiceForm.invoiceType === '20' ? invoiceFormRules.companyAddress : [{ required: false, message: '', trigger: 'blur' }]">
                        <el-input v-model="invoiceForm.companyAddress" :maxlength="100"></el-input>
                    </el-form-item>
                    <el-form-item label="注册固定电话:" prop="companyPhone"
                        :rules="invoiceForm.invoiceType === '20' ? invoiceFormRules.companyPhone : [{ required: false, message: '', trigger: 'blur' }]">
                        <el-input v-model="invoiceForm.companyPhone" :maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="是否为默认：">
                        <el-checkbox v-model="invoiceForm.flagAdd">
                            默认发票
                        </el-checkbox>
                    </el-form-item>
                </el-form>
                <div @click="invoiceSaveHandle" class="saveAdd" v-loading="buttonLoading">提交</div>
          </div>
      </div>

    <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="invoiceSaveHandle()" :loading="buttonLoading">保 存</el-button>
    </div> -->
  </el-dialog>
</template>
<script>
import { taxReg, tellReg } from '@/utils/reg'
export default {
  data () {
    return {}
  },
  props: {
    invoiceForm: {
      type: Object,
      default: null
    },
    invoiceVisible: {
      type: Boolean,
      default: false
    },
    buttonLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogTitle () {
      return this.invoiceForm && this.invoiceForm.invoiceId ? '编辑发票抬头' : '新增发票抬头'
    },
    invoiceFormRules () {
      return {
        companyName: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        taxpayerIdentity: [{
          required: true,
          pattern: taxReg,
          message: '请输入正确的税务登记证号',
          trigger: 'blur'
        }],
        bankAccountNo: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        companyAddress: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        openingBank: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        companyPhone: [{
          required: true,
          pattern: tellReg,
          message: '请输入正确的注册固定电话',
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    closeInviceHandle () {
      this.$refs['invoiceForm'].resetFields()
      this.$emit('closeInviceHandle')
    },
    invoiceSaveHandle () {
      this.$refs['invoiceForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        console.log(this.invoiceForm)
        this.$emit('invoiceSaveHandle')
      })
    }
  }
}
</script>
<style lang='scss' scoped>
    @import '../common/dialogStyle.scss';
</style>
